import React from 'react';
import './Description.css';
import { Category } from '../data/RowData';
import { useAppContext } from '../services/AppService';

export const Description: React.FC = () => {
	const { state, setState } = useAppContext();

	return (
		<div className='ergo-description' onClick={() => setState('hamburgerMenuIsOpen', false)}>
			<h1 className='ergo-title'>
				{state.category === Category.ver ?
					"Firmware Version Information" :
					"Ergotron Software Downloads"
				}
			</h1>
			<h4 className='ergo-subtitle'>
				{state.category === Category.ver ?
					<>This page is maintained by Ergotron Software Engineering and provides firmware version information for Ergotron products. <span className='instructions'>Click on Release Notes</span> to see more information.</> :
					"This page is maintained by Ergotron Software Engineering and provides links for downloading applications, drivers, and documentation for Ergotron products."
				}
			</h4>
		</div>
	)
}